import { useQuery, useQueryClient } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetBuyFactorList(page = 1) {
  const res = await AxiosT.get(`/buy-factor-list?page=${page}`);
  return res.data;
}

export function useGetBuyFactorList() {
  return useQuery("getBuyFactorList", fetchGetBuyFactorList);

  //   const queryClient = useQueryClient();

  //   return useQuery(
  //     ["getBuyFactorList", page],
  //     () => fetchGetBuyFactorList(page),
  //     {
  //       onSuccess: (data) => {
  //         // prefetch next page
  //         if (data.data.meta_data.current_page < data.data.meta_data.last_page) {
  //           queryClient.prefetchQuery(["getBuyFactorList", page + 1], () =>
  //             fetchGetBuyFactorList(page + 1)
  //           );
  //         }
  //       },
  //     }
  //   );
}
